import React from 'react'
import { storiesOf } from '@storybook/react'

import { StorePremiumProduct } from 'protos'

import Grid from '@material-ui/core/Grid'

import PremiumMembership from 'components/PremiumMembership'

const silver = StorePremiumProduct.create({
  type: StorePremiumProduct.Type.SILVER,
  title: 'Foosio Premium Silver',
  summary: 'Ad Free and more Daily Bonus koins',
  price: [{ value: 1.09, currency: 0 }],
  duration: 30,
  detailItem: [{
    title: '100% banner-free',
    detail: 'We hide all banners',
  }, {
    title: 'Double daily bonus',
    detail: 'We raise the daily bonus from 50 to 100 koins',
  }]
})

const gold = StorePremiumProduct.create({
  type: StorePremiumProduct.Type.GOLD,
  title: 'Foosio Premium Gold',
  summary: 'Ad Free, Player Autosubstitution, Extra Push Notifications and much more',
  price: [{ value: 4.99, currency: 0 }],
  duration: 30,
  detailItem: [...silver.detailItem, {
    title: 'Extended "Team assistant"',
    detail: 'You choose 0 or up to 3 players and the "Team assistant" magically ' +
      'completes your team with the best players.',
  }, {
    title: 'Useful Player Popularity stats',
    detail: 'We show you which players are popular among the most successful Foosio ' +
      'users. The more stars, the more often the player is selected.',
  }]
})

const activeSilver = StorePremiumProduct.create({
  ...silver,
  duration: 12,
})

const activeGold = StorePremiumProduct.create({
  ...gold,
  duration: 1,
})

storiesOf('PremiumMembership', module)
  .add('default', () => (
    <Grid direction="row" spacing={2} container>
      <Grid xs={4} item>
        <PremiumMembership />
      </Grid>
      <Grid xs={4} item>
        <PremiumMembership membership={silver} />
      </Grid>
      <Grid xs={4} item>
        <PremiumMembership membership={gold} />
      </Grid>

      <Grid xs={6} item>
        <PremiumMembership membership={silver} activeMembership={activeSilver} />
      </Grid>
      <Grid xs={6} item>
        <PremiumMembership membership={gold} activeMembership={activeGold} />
      </Grid>

      <Grid xs={6} item>
        <PremiumMembership membership={silver} activeMembership={activeSilver} isDetailed />
      </Grid>
      <Grid xs={6} item>
        <PremiumMembership membership={gold} isDetailed />
      </Grid>
    </Grid>
  ))
